var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.6,27.4c4.4-4.4,11.7-4.4,16.1,0,4.4,4.4,4.4,11.7,0,16.1l-27,27c-1.6,1.6-3.6,2.7-5.8,3.1l-11.2,2.2c-1.2.2-2.5-.1-3.4-1s-1.3-2.2-1-3.4l2.2-11.2c.4-2.2,1.5-4.2,3.1-5.8l27-27ZM60.3,32.8c-1.5-1.5-3.9-1.5-5.4,0l-1.4,1.4,5.4,5.4,1.4-1.4c1.5-1.5,1.5-3.9,0-5.4ZM53.5,44.9l-5.4-5.4-20.2,20.2c-.5.5-.9,1.2-1,1.9l-1.1,5.6,5.6-1.1c.7-.1,1.4-.5,1.9-1l20.2-20.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50.8,68.4h28.8c1.8,0,3.5,1.2,3.8,3s-1.4,4.6-3.7,4.6h-28.9c-2.1,0-3.8-1.7-3.8-3.8h0c0-2.1,1.7-3.8,3.8-3.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeSign);
export default __webpack_public_path__ + "static/media/acae_sign.f6ba0d9d.svg";
export { ForwardRef as ReactComponent };